import React, { FormEvent, useState } from 'react'
import {
  Typography,
  TextField,
  CircularProgress,
  Button,
  useTheme,
} from '@mui/material'
import { useAuth } from '../redux/slices/auth/useAuth'

type Props = {
  onResetPassword: (email: string) => void
}

const ProfileResetPassword = (props: Props) => {
  const { onResetPassword } = props;
  const { updating } = useAuth()
  const theme = useTheme();

  const [email, setEmail] = useState('')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    onResetPassword(email);
  }
  return (
    <>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          color: theme.palette.grey[800],
          fontWeight: 500,
          mb: 3
        }}
      >
        Reset Password
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          type="email"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
        />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={updating}
          sx={{
            mt: 3,
            mb: 2,
            height: 48,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {updating ? (
            <CircularProgress size={24} />
          ) : (
            'Send Reset Link'
          )}
        </Button>
      </form>
    </>
  )
}

export default ProfileResetPassword